import { render, staticRenderFns } from "./InformationOwnerTable.vue?vue&type=template&id=a700cc12"
import script from "./InformationOwnerTable.vue?vue&type=script&lang=js"
export * from "./InformationOwnerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports